export var ViewType;
(function (ViewType) {
    ViewType["Custom"] = "custom";
    ViewType["List"] = "list";
})(ViewType || (ViewType = {}));
